import React from "react";

import styled from "styled-components";
import Select, { components } from "react-select";

export const customStyles = {
  control: (provided) => ({
    ...provided,
    minHeight: 56,
    borderRadius: 12,
    backgroundColor: "var(--white-color)",
    border: "1px solid var(--primary-color)",
    outline: 0,
    cursor: "pointer",
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected && "var(--blue-color-light)",
    cursor: "pointer",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    color: "var(--text-color-muted)",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    minWidth: 50,
    justifyContent: "center",
    background: "var(--blue-color-light)",
    borderTopLeftRadius: 12,
    borderBottomLeftRadius: 12,
  }),
};

export const StyledSelect = styled(Select)`
  /* Add text-indent to select options */
  [id^="react-select-2-group"] + div {
    div[id^="react-select-2-option"] {
      text-indent: 1rem;
    }
  }
`;
export const IndicatorsContainer = (props) => {
  return <StyledIndicatorsContainer {...props} />;
};

const StyledIndicatorsContainer = styled(components.IndicatorsContainer)`
  svg {
    fill: var(--primary-color);
  }
`;

export const StyledOption = styled(components.Option)`
  font-weight: ${({ $optionType }) => $optionType === "optgroup" && 700};
  text-indent: ${({ $optionType }) => $optionType === "grade" && "1rem"};
`;

export const StyledCheckbox = styled.span`
  background: ${({ checked }) => checked && "var(--tertiary-color)"};
  position: relative;
  width: 15px;
  height: 15px;
  border: 1px solid var(--primary-color);
  border-radius: 2px;
  &:after {
    content: "";
    position: absolute;
    display: none;
  }
  input[type="checkbox"] {
    position: absolute;
    display: none;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
`;
